import React, {FC} from "react";
import { Typography, Box, makeStyles, Grid, Button } from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";

interface Props {
	id: any,
	title: string,
	date: string,
	setSelectedRecord: any,
	setOpenModal: any,
	styles?: any,
    isAdmin?: boolean,
}

const useStyle = makeStyles(() => ({
    itemContainer: {
        padding: "20px 0",
    },
    itemContainerAdmin: {
        border: "1px solid #dadada",
        padding: "20px 10px",
    },
    textSecondary: {
        marginTop: "10px",
        fontSize: 18
    },
    textSecondaryAdmin: {
        fontSize: 14
    },
    button: {
        padding: "12px 44px"
    }
}));

const RecordListItem: FC<Props> = ({id, title, date, setSelectedRecord, setOpenModal, styles, isAdmin = false} : Props) => {
    const classes = useStyle();
    const theme = useTheme();

    return (
        <Grid container className={`${isAdmin ? classes.itemContainerAdmin : classes.itemContainer} ${styles}`}>
            <Grid item xs={12} sm={9}>
                <Box>
                    <Typography variant={isAdmin ? "h6" : "h3"}>{title}</Typography>
                    <Typography color="textSecondary" className={isAdmin ? classes.textSecondaryAdmin : classes.textSecondary}>{date}</Typography>
                </Box>
            </Grid>
            <Grid item container justify="flex-end" xs={12} sm={3}>
                <Button type="button" variant="contained" color="primary"
                    className={classes.button}
                    onClick={() => {
                        setOpenModal(true);
                        setSelectedRecord(id);
                    }}
                >
					View
                </Button>
            </Grid>
        </Grid>
    );
};

export default RecordListItem;
